module.exports = __webpack_public_path__ + "img/f-thermometer-img8-1.065389be.png";